import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CampaignTroubleshootingComponent } from './components/campaign-troubleshooting/campaign-troubleshooting.component';

const routes: Routes = [
  {
    path: '',
    component: CampaignTroubleshootingComponent,
    data: { title: 'Troubleshooting' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CampaignTroubleshootingRoutingModule {}
